"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECOVERY_THRESHOLD_PARTS = exports.RECOVERY_TOTAL_PARTS = void 0;
exports.RECOVERY_TOTAL_PARTS = 5;
exports.RECOVERY_THRESHOLD_PARTS = 3;
